import styled from "@emotion/styled";
import { colors } from "../../styles/colors";
import { fonts } from "../../styles/fonts";

export const PrivacyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const PrivacyContent = styled.div`
  width: 100%;
  max-width: 832px;
  padding: 16px;
  @media (min-width: 769px) {
    padding: 0px;
  }
`;

export const PrivacyTitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0px 0px 0px;
  padding: 30px 0px;
  border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
`;

export const PrivacyTitleLeft = styled.div`
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  color: ${colors.GREY_DARK};
`;

export const PrivacyTitleRight = styled.div`
  font-family: ${fonts.latoRegular};
  font-size: 14px;
  color: ${colors.GREY_SEMIDARK};
`;

export const SectionStyled = styled.section`
  padding: 30px 0px;
  border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
`;

export const TextBlock = styled.p`
  font-family: ${fonts.latoRegular};
  font-size: 16px;
  color: ${colors.GREY_SEMIDARK};
  margin: 0px 0px 16px 0px;
  line-height: 27px;
`;

export const TextBold = styled.span`
  font-family: ${fonts.latoBold};
  color: ${colors.GREY_DARK};
`;

export const LinksList = styled.div`
  margin: 30px 0px 10px 0px;
`;

export const LinksListItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  margin: 0px 0px 20px 0px;
  cursor: pointer;
  &:last-child {
    margin: 0px;
  }
`;

export const LinksItemNumber = styled.div`
  width: 30px;
  font-family: ${fonts.latoRegular};
  font-size: 18px;
  color: ${colors.GREY};
`;

export const LinksItemLink = styled.a`
  font-family: ${fonts.latoRegular};
  font-size: 18px;
  color: ${colors.GREY_DARK};
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 20px 0px;
`;

export const SectionTitleText = styled.div`
  font-family: ${fonts.latoRegular};
  font-size: 20px;
  color: ${colors.GREY_DARK};
`;

export const SectionTitleBack = styled.div`
  font-family: ${fonts.latoRegular};
  font-size: 16px;
  color: ${colors.RED};
  cursor: pointer;

  .icon {
    display: inline-block;
    vertical-align: middle;
    width: 24px;
    height: 24px;
    margin: 0px 0px 0px 5px;
    fill: ${colors.RED} !important;
    stroke: ${colors.RED} !important;
  }
`;

export const BackLink = styled.span`
  display: none;
  @media (min-width: 769px) {
    display: inline;
  }
`;

export const SummaryBlock = styled.div``;

export const ListSectionNumber = styled.div`
  position: relative;
  width: 30px;
  font-family: ${fonts.latoRegular};
  font-size: 20px;
  color: ${colors.GREY_SEMIDARK};
`;

export const ListSectionAnchor = styled.div`
  position: absolute;
  top: -80px;
`;

export const SectionTitleLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const ListSectionContent = styled.section`
  padding: 0px 0px 0px 30px;
`;

export const SublistItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  &:before {
    content: "○";
    width: 30px;
    text-align: center;
    color: ${colors.GREY};
  }
  ${(props) =>
    props.nocircle &&
    `&:before {
    content: " ";
  }`}
`;

export const SublistItemContent = styled.div`
  width: 100%;
`;

export const ExternalLink = styled.a`
  color: ${colors.BLUE_LINK};
  cursor: pointer;
  text-decoration: underline;
`;
